/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CounselorDutyType } from './CounselorDutyType';
import {
    CounselorDutyTypeFromJSON,
    CounselorDutyTypeFromJSONTyped,
    CounselorDutyTypeToJSON,
    CounselorDutyTypeToJSONTyped,
} from './CounselorDutyType';

/**
 * 
 * @export
 * @interface BlockedPeriodResponse
 */
export interface BlockedPeriodResponse {
    /**
     * 
     * @type {string}
     * @memberof BlockedPeriodResponse
     */
    id: string;
    /**
     * 
     * @type {CounselorDutyType}
     * @memberof BlockedPeriodResponse
     */
    dutyType: CounselorDutyType;
    /**
     * 
     * @type {Date}
     * @memberof BlockedPeriodResponse
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof BlockedPeriodResponse
     */
    to: Date;
}



/**
 * Check if a given object implements the BlockedPeriodResponse interface.
 */
export function instanceOfBlockedPeriodResponse(value: object): value is BlockedPeriodResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dutyType' in value) || value['dutyType'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function BlockedPeriodResponseFromJSON(json: any): BlockedPeriodResponse {
    return BlockedPeriodResponseFromJSONTyped(json, false);
}

export function BlockedPeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockedPeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dutyType': CounselorDutyTypeFromJSON(json['dutyType']),
        'from': (new Date(json['from'])),
        'to': (new Date(json['to'])),
    };
}

export function BlockedPeriodResponseToJSON(json: any): BlockedPeriodResponse {
    return BlockedPeriodResponseToJSONTyped(json, false);
}

export function BlockedPeriodResponseToJSONTyped(value?: BlockedPeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dutyType': CounselorDutyTypeToJSON(value['dutyType']),
        'from': `${value['from'].getFullYear()}-${String(value['from'].getMonth()+1).padStart(2,'0')}-${String(value['from'].getDate()).padStart(2,'0')}`,
        'to': `${value['to'].getFullYear()}-${String(value['to'].getMonth()+1).padStart(2,'0')}-${String(value['to'].getDate()).padStart(2,'0')}`,
    };
}

